import { RequestEmailChangeResult, TRequestEmailChange } from '@onesource/schemas';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import axios from '../../common/axios';
import { ENTITY } from './entity';
import { getEmailChangePendingQueryKey } from './use-email-change-pending-query';

/**
 * Starts the secure email-change flow: verifies the current password server-side
 * and queues the two verification emails. Does NOT change the login email — that
 * only happens when the user clicks the activation link in the new inbox.
 *
 * Errors (401 wrong password, 409 already in use / pending, 429 rate-limited) are
 * surfaced to the caller so the dialog can render them inline.
 */
export const useRequestEmailChangeMutation = () => {
  const qc = useQueryClient();

  return useMutation<RequestEmailChangeResult, Error, TRequestEmailChange>({
    mutationFn: async (payload: TRequestEmailChange) => {
      const { data } = await axios.post<RequestEmailChangeResult>(`${ENTITY}/email-change/request`, payload);
      return data;
    },
    onSuccess: async () => {
      await qc.invalidateQueries({ queryKey: getEmailChangePendingQueryKey() });
    },
  });
};
